import regionComparator from "./regionComparator";

/*
Submit {{a photograph|file}} each odd day of next week. That is,
on [[Tuesday|2018-01-16]] and [[Thursday|2018-01-18]]. You must
also submit {{a summary on Friday|2018-01-19|notes}}.
 */

class DescriptionParser {

    constructor(desc) {
        const splitter = "|";
        this.stripped = desc; // soon to be overwritten
        this.regions = [];
        let start = 0;
        const toDate = s => {
            if (s.indexOf("T") < 0) {
                s += "T00:00:00";
            }
            const d = new Date(s);
            // noinspection JSCheckFunctionSignatures
            return isNaN(d) ? undefined : d;
        };
        for (let i = 0; ; i++) {
            if (i >= 50) {
                console.log("infinite loop?", desc);
                break;
            }
            const ri = desc.indexOf("{{", start);
            if (ri < 0) break;
            // region!
            const ei = desc.indexOf("}}", ri);
            if (ei < ri) break;
            const spec = desc.substring(ri + 2, ei)
                .split(splitter);
            if (spec.length === 1) {
                // something's amiss, just skip it
                start = ei;
                continue;
            }
            const name = spec[0];
            const region = {
                name,
            };
            let accept = spec[spec.length - 1]
                .trim()
                .split(",")
                .map(it => it.trim())
                .filter(it => it.length > 0);
            if (accept.length > 0) {
                region.accept = accept;
            }
            if (spec.length === 3) {
                // with deadline
                region.when = toDate(spec[1]);
            }
            this.regions.push(region);
            if (ri > 0 && desc[ri - 1] === "!") {
                // silent
                desc = desc.substring(0, ri - 1)
                    + desc.substring(ei + 2);
                start = ri;
            } else {
                desc = desc.substring(0, ri)
                    + name
                    + desc.substring(ei + 2);
                start = ri + name.length;
            }
        }
        this.regions.sort(regionComparator);
        // noinspection CheckTagEmptyBody
        this.stripped = desc
            .replace(/%(-?[0-9]+)/g, `<Counters n="$1" className="smash-icon"></Counters>`);
    }

}

export default DescriptionParser;



// WEBPACK FOOTER //
// ./src/util/DescriptionParser.js